export const chimeraRawDataTypeValues = [
    'all',
    'boot',
    'mains',
    'power',
    'fault',
    'cell',
    'ack',
    'init',
    'update',
    'milking',
    'pickup',
    'wash',
];

export const classicRawDataTypeValues = [
    'all',
    'NSS',
    'SVL', 
    'BEM', 
    'BleCap', 
    'DBG:BLE',
];

export type ChimeraRawDataType = typeof chimeraRawDataTypeValues[number];
export type ClassicRawDataType = typeof classicRawDataTypeValues[number];